import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CobrancaDTO, Invoice, ParcelamentoDTO, VerifyCardRequestDto, VerifyCardResponseDto } from '../types';
import { endpoint } from '../../../environments';

@Injectable({
  providedIn: 'root',
})
export class PagamentoService {
  private url = endpoint(`/api/solucao-pagamentos`);

  constructor(private http: HttpClient) { }

  getInvoice(uuid: string): Observable<Invoice> {
    return this.http.get<Invoice>(`${this.url}/fatura/${uuid}`);
  }

  searchBin(cartao: VerifyCardRequestDto): Observable<VerifyCardResponseDto> {
    return this.http.post<VerifyCardResponseDto>(`${this.url}/cartao/consulta-bin`, cartao);
  }

  payInvoice(
    uuidFatura: string,
    pagamentoFatura: any
  ): Observable<CobrancaDTO> {
    return this.http.post<CobrancaDTO>(`${this.url}/fatura/${uuidFatura}/pagar`, pagamentoFatura);
  }

  getParcelamento(uuidFatura: string): Observable<ParcelamentoDTO> {
    return this.http.get<ParcelamentoDTO>(`${this.url}/fatura/${uuidFatura}/parcelamento`);
  }
}
